
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Widget": () => {
return Promise.all(/*  | __federation_expose_Widget */ [__webpack_require__.e("787"), __webpack_require__.e("380"), __webpack_require__.e("941")]).then(() => (() => (__webpack_require__(8674))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };